import { Injectable } from "@angular/core";
import { WebApiClient } from "../../web-api-client.service";
import { WebApiService } from "../../web-api.service";

export class CalendarCountDto {
  Year: number;
  YearCount: number;
  LastEditTime?: Date;
}

export class DentalHolidayRuleCalendarDto {
  Year: number;
  LastEditTime?: Date | string;
  IsUnchanged?: boolean;
  Dates: { [date: string]: string[] } = {};
}

@Injectable({
  providedIn: 'root'
})

export class CalendarApi {
  constructor(
    private webApiFactory: WebApiClient) {
    this.api = this.webApiFactory.createHisService('system/calendar');
    // this.api.enableLoader = false;
  }

  api: WebApiService;

  async ImportCalendar(year: number): Promise<any> {
    return await this.api.post('ImportCalendar?year=' + year, {}).toPromise();
  }

  async CountCalendar(year: number): Promise<CalendarCountDto[]>{
    return await this.api.get('CountCalendar/' + year).toPromise<CalendarCountDto[]>();
  }

  async GetDentalHolidayRuleCalendar(year: number): Promise<DentalHolidayRuleCalendarDto> {
    return await this.api.get('GetDentalHolidayRuleCalendar/' + year).toPromise<DentalHolidayRuleCalendarDto>();
  }

  async GetDentalHolidayRuleCalendarIfChanged(year: number, knownLastEditTime?: string): Promise<DentalHolidayRuleCalendarDto> {
    const versionQuery = knownLastEditTime
      ? '?knownLastEditTime=' + encodeURIComponent(knownLastEditTime)
      : '';
    return await this.api.get('GetDentalHolidayRuleCalendarIfChanged/' + year + versionQuery)
      .toPromise<DentalHolidayRuleCalendarDto>();
  }
}
